module.exports = {
    resolution: {width:1920, height:1080},
    loadscreen: {
        loadbar:{
            position:{x:663, y:1009}
        }
    }
};



//////////////////
// WEBPACK FOOTER
// ./cfg/screen-config.js
// module id = 13
// module chunks = 0